import React, { useState } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { RANKING_TYPES } from '../utils/rankingTypes';

export default function HomeRankings({
  rankings = {},
  onRankings,
  onPlayer,
  onSearch,
  isLoading,
  loadError,
  retry,
}) {
  const [division, setDivision] = useState('doubles');
  const type = RANKING_TYPES[division];
  const leaders = (rankings[type.list] || [])
    .filter(
      (player) =>
        player[type.count] > 0 && typeof player[type.rank] === 'number',
    )
    .slice(0, 5);
  return (
    <section className="club-section" aria-labelledby="home-rankings-title">
      <div className="club-section-head">
        <h2 id="home-rankings-title" className="club-section-title">
          클럽 순위
        </h2>
        <button className="club-text-link" onClick={onSearch}>
          <Search size={17} aria-hidden="true" />
          선수 검색
        </button>
      </div>
      <div className="club-panel club-home-ranking-panel">
        <div className="club-home-ranking-toolbar">
          <div className="club-segments" aria-label="홈 순위 경기 구분">
            {Object.entries(RANKING_TYPES).map(([key, item]) => (
              <button
                key={key}
                aria-pressed={division === key}
                onClick={() => setDivision(key)}
              >
                {item.name}
              </button>
            ))}
          </div>
          <button
            className="club-text-link"
            aria-label={`${type.name} 전체 순위`}
            onClick={() => onRankings(division)}
          >
            전체 보기
            <ArrowRight size={16} aria-hidden="true" />
          </button>
        </div>
        <section aria-label={`${type.name} 순위`}>
          {isLoading ? (
            <p className="club-status" role="status">
              순위를 불러오는 중…
            </p>
          ) : loadError ? (
            <div className="club-error" role="alert">
              <p>순위를 불러오지 못했습니다.</p>
              <button className="club-text-link" onClick={retry}>
                다시 시도
              </button>
            </div>
          ) : (
            <>
              {leaders.length ? (
                <ol className="club-home-rank-list">
                  {leaders.map((player) => (
                    <li key={player.id}>
                      <a
                        href={`#playerDetail/${encodeURIComponent(player.id)}`}
                        onClick={(event) => {
                          event.preventDefault();
                          onPlayer(player.id);
                        }}
                      >
                        <span className="club-rank-number">
                          {player[type.rank]}
                          <span className="sr-only">위</span>
                        </span>
                        <span>{player.name}</span>
                        <strong>
                          <span className="sr-only">레이팅 </span>
                          {(player[type.rating] ?? 1500).toLocaleString()}
                        </strong>
                      </a>
                    </li>
                  ))}
                </ol>
              ) : (
                <p className="club-status">
                  {type.name} 경기 등록 후 순위가 표시됩니다.
                </p>
              )}
            </>
          )}
        </section>
      </div>
    </section>
  );
}
